export const environment = {
  production: true,
  BASE_DOMAIN:'https://samsung.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://samsung.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://samsung.apollosupplychain.com/',
  WebsocketUrl: 'wss://samsung.apollosupplychain.com/websocket-service/ws/notifications'
};
